<template>
  <div class="iq-card-header">
    <div class="iq-card-body">
      <div class="iq-card p-2">
        <tab-nav :tabs="true" id="myTab-1">
          <tab-nav-items
            v-for="(tab, index) in tabs"
            :key="tab.id"
            :active="activeTab === index"
            :id="tab.id"
            :ariaControls="tab.ariaControls"
            role="tab"
            :ariaSelected="activeTab === index"
            :title="tab.title"
            @click="activeTab = index"
          />
        </tab-nav>

        <tab-content id="myTabContent">
          <tab-content-item
            v-for="(tab, index) in tabs"
            :key="tab.id"
            :active="activeTab === index"
            :id="tab.ariaControls"
            :aria-labelled-by="tab.id"
          >
            <component :is="tab.component" />
          </tab-content-item>
        </tab-content>
      </div>
    </div>
  </div>
</template>

<script>
import { core } from "@/config/pluginInit";
import BusinessSettingsTab from "./BusinessSettings/BusinessSettingsTab.vue";
import BranchSettingsTab from "./BranchSettings/BranchSettingsTab.vue";
import MobileAppSettingsTab from "./MobileAppSettings/MobileAppSettingsTab.vue";
import AccountSettingsTab from "./AccountSettings/AccountSettingsTab.vue";
import TabletAppSettingsTab from "./TabletAppSettings/TabletAppSettingsTab.vue";
export default {
  name: "SettingsList",
  components: {
    BusinessSettingsTab,
    BranchSettingsTab,
    MobileAppSettingsTab,
    AccountSettingsTab,
    TabletAppSettingsTab
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          id: "Business-Settings",
          ariaControls: "businessSettings",
          title: "Business Settings",
          component: BusinessSettingsTab
        },
        {
          id: "Branch-Settings",
          ariaControls: "branchSettings",
          title: "Branch Settings",
          component: BranchSettingsTab
        },
        {
          id: "Tablet-App-Settings",
          ariaControls: "TabletAppSettings",
          title: "Tablet App Settings",
          component: TabletAppSettingsTab
        },
        {
          id: "Mobile-App-Settings",
          ariaControls: "MobileAppSettings",
          title: "Mobile AppSettings",
          component: MobileAppSettingsTab
        },
        {
          id: "Account-Settings",
          ariaControls: "AccountSettings",
          title: "Account Settings",
          component: AccountSettingsTab
        }
      ]
    };
  },
  computed: {},
  async mounted() {
    core.index();
  },
  methods: {}
};
</script>

<style scoped></style>
